import { ENV_CONFIG } from '@/envConfig.ts';
import { wait } from '@/common/utils/wait.ts';
import { ResponseBase } from '@/common/api/schemas.ts';

export type MockOptions<TResponse extends ResponseBase> = {
  mock?: (() => TResponse) | TResponse;
};

export async function handleMock<TResponse extends ResponseBase>(
  mockOptions: MockOptions<TResponse>
) {
  if (ENV_CONFIG.apiDebugDelay > 0) {
    await wait(ENV_CONFIG.apiDebugDelay);
  }
  const handler = mockOptions.mock;

  if (typeof handler === 'function') {
    return handler();
  }
  return handler;
}
